import React from "react";
import ReportItemEntityListRow from "./ReportItemEntityListRow";

export default function BasicGraphDetailEntity({ entity, children }) {
  return (
    <div className="report-scheme-report-item-row">
      <ReportItemEntityListRow entity={entity} itemName="Detay" />
      {children && children}
    </div>
  );
}
